module.exports = __webpack_public_path__ + "img/11.dfcb3e5d.png";